import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Menus',
    href: '#menus'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Location',
    href: '#location'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${isScrolled ? 'bg-background/95 backdrop-blur-md border-border py-2 shadow-lg' : 'bg-transparent border-transparent py-4'}`} data-id="element-161">
      <div className="container mx-auto px-4 md:px-6" data-id="element-162">
        <div className="flex items-center justify-between" data-id="element-163">
          {/* Logo */}
          <a href="#" className="group flex flex-col" onClick={e => scrollToSection(e, '#hero')} data-id="element-164">
            <span className="font-serif text-xl md:text-2xl font-bold text-foreground tracking-tight" data-id="element-165">
              The Old Mill
            </span>
            <span className="h-0.5 w-12 bg-primary transition-all group-hover:w-full duration-300" data-id="element-166"></span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-167">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors uppercase tracking-wide" data-id="element-168">
                {link.name}
              </a>)}
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-169">
            <a href="#reservation" onClick={e => scrollToSection(e, '#reservation')} className="hidden md:inline-flex items-center justify-center px-6 py-2 text-sm font-bold text-primary-foreground bg-primary rounded-md hover:bg-primary/90 transition-colors shadow-[0_0_15px_rgba(var(--primary),0.3)]" data-id="element-170">
              Book a Table
            </a>

            <button className="md:hidden p-2 text-foreground hover:text-primary transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-171">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-172" /> : <Menu className="h-6 w-6" data-id="element-173" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-background border-b border-border p-4 shadow-xl animate-accordion-down" data-id="element-174">
          <nav className="flex flex-col space-y-4" data-id="element-175">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-lg font-medium text-foreground hover:text-primary transition-colors py-2 border-b border-border/50" data-id="element-176">
                {link.name}
              </a>)}
            <a href="#reservation" onClick={e => scrollToSection(e, '#reservation')} className="mt-4 inline-flex items-center justify-center w-full px-6 py-3 text-base font-bold text-primary-foreground bg-primary rounded-md hover:bg-primary/90 transition-colors" data-id="element-177">
              Book a Table
            </a>
          </nav>
        </div>}

      {/* Bottom Gold Line */}
      <div className="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-primary/50 to-transparent opacity-50" data-id="element-178"></div>
    </header>;
}